import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getPaymentChannelList } from '../../../../../services/payment-channels'
import { Box, Group, Center, Loader, Text, Image } from '@mantine/core'

const defaultPaymentList = {
  '1': {
    id: null,
    name: '', 
    logo: ''
  }
}

const OrderPaymentMethod = () => {
  const { paymentMethods } = useSelector(state => state.order_detail)
  const [loadingPaymentMethod, setLoadingPaymentMethod] = useState(true)
  const [paymentMethodList, setPaymentMethodList] = useState(defaultPaymentList)

  const handleGetPaymentChannelList = async () => {
    setLoadingPaymentMethod(true)
    const params = {
      'page[limit]': 100
    }
    try {
      const response = await getPaymentChannelList({ 'page[limit]': 100 })
      if (response.success && response.data) {
        const dataPaymentChannel = response.data
        const remapData = dataPaymentChannel.map((val) => {
          return {
            id: val.id || val.attributes?.id,
            name: val.attributes?.name,
            logo: val.attributes?.logo_url,
          }
        })

        const convertToObject = remapData.reduce((result, value) => ({...result,[value.id]: value }), {})
        setPaymentMethodList(convertToObject)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingPaymentMethod(false)
    }
  }

  useEffect(() => {
    handleGetPaymentChannelList()
  }, [paymentMethods])

  const loadingDataPayment = () => {
    return (
    <Center w='auto' h={48}>
      <Loader size='sm' type='dots' />
    </Center>
    )
  }

  const mappingDataPayment = (dataPayment) => {
    if (dataPayment.length > 0) {

      const mappingOrderPayment = (data) => {
        if (Object.values(paymentMethodList).length > 0) {
          const remap = data.map((val, index) => {
            const paymentMethod = paymentMethodList[val.payment_channel_id]
            return (
              <Box key={index}>
                {paymentMethod?.logo && (
                  <Image src={paymentMethod.logo} w={50} h={26} fit='contain' mb={4} />
                )}
                <Text fz={12} c='gray.6'>{paymentMethod?.name || ''}</Text>
              </Box>
            )
          })
          return remap
        }
      }

      return (
        <Group>{mappingOrderPayment(dataPayment)}</Group>
      )
    } else {
      return (
        <Box>
          <Text fz={14} c='gray.5' my={19}>"This order does not have a payment method yet"</Text>
        </Box>
      )
    }
  }
  
  return (
    <Box my={6}>
      {loadingPaymentMethod ? loadingDataPayment() : mappingDataPayment(paymentMethods)}
    </Box>
  )
}

export default OrderPaymentMethod